import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query"
import { getStudentSupportOrbit } from "./api"

export const studentSupportOrbitQueryOptions = (studentNo: string) =>
    queryOptions({
        queryKey: ['studentSupportOrbit', studentNo],
        queryFn: () => getStudentSupportOrbit(studentNo),
    })

export function useStudentSupportOrbit(studentNo: string) {
    return useQuery(studentSupportOrbitQueryOptions(studentNo))
}

export function useStudentSupportOrbitSuspense(studentNo: string) {
    return useSuspenseQuery(studentSupportOrbitQueryOptions(studentNo))
}
